import styled from 'styled-components';

export const Container = styled.div`
    height: 100%;
    padding: 24px;
    background: ${({ theme }) => theme.tokens?.BaseColorWhite || '#ffffff'};
    border-radius: ${({ theme }) => theme.tokens?.BaseSizeBorderRadiusLg || '8px'};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border: ${({ theme }) => `1px solid ${theme.uiBricks?.defaultInputFieldBorderColor || '#E0E0E0'}`};
    display: flex;
    gap: 40px;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 24px;
    }
`;

export const LeftSection = styled.div`
    flex: 1;
    min-width: 300px;
`;

export const RightSection = styled.div`
    flex: 1;
    padding-left: 20px;
    border-left: ${({ theme }) => `1px solid ${theme.uiBricks?.defaultInputFieldBorderColor || '#E0E0E0'}`};

    @media (max-width: 768px) {
        padding-left: 0;
        border-left: none;
        border-top: ${({ theme }) => `1px solid ${theme.uiBricks?.defaultInputFieldBorderColor || '#E0E0E0'}`};
        padding-top: 20px;
    }
`;

export const Title = styled.h2`
    font-size: ${({ theme }) => theme.tokens?.SemTypographyListLg?.fontSize || '18px'};
    font-weight: 800;
    margin: 0 0 8px 0;
    text-align: left;
`;

export const Description = styled.p`
    font-size: ${({ theme }) => theme.tokens?.SemTypographyListSm?.fontSize || '14px'};
    color: ${({ theme }) => theme.uiBricks?.nextStepsDescriptionColor || '#666666'};
    margin: 0 0 24px 0;
    line-height: 1.4;
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const InputGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const InputContainer = styled.div`
    display: flex;
    gap: 12px;
`;

export const Label = styled.label`
    font-size: ${({ theme }) => theme.tokens?.SemTypographyListSm?.fontSize || '14px'};
    font-weight: 500;
    margin-bottom: 4px;
`;

export const Input = styled.input`
    flex: 1;
    padding: 12px 16px;
    border: 1px solid #d1d5db;
    border-radius: ${({ theme }) => theme.tokens?.BaseSizeBorderRadiusSm || '4px'};
    font-size: ${({ theme }) => theme.tokens?.SemTypographyListSm?.fontSize || '14px'};
    background: ${({ theme }) => theme.tokens?.BaseColorWhite || '#ffffff'};
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.palette?.primary?.main || '#1976d2'};
        box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
    }

    &:disabled {
        background-color: ${({ theme }) => theme.palette?.grey?.A100 || '#f5f5f5'};
        color: ${({ theme }) => theme.tokens?.BaseColorGray400 || '#999'};
        cursor: not-allowed;
    }

    &::placeholder {
        color: ${({ theme }) => theme.tokens?.BaseColorGray400 || '#999'};
    }
`;

export const SubmitButton = styled.button`
    padding: 12px 20px;
    background-color: ${({ theme }) => theme.palette?.primary?.main || '#1976d2'};
    color: ${({ theme }) => theme.tokens?.BaseColorWhite || '#ffffff'};
    border: none;
    border-radius: ${({ theme }) => theme.tokens?.BaseSizeBorderRadiusSm || '4px'};
    font-size: ${({ theme }) => theme.tokens?.SemTypographyListSm?.fontSize || '14px'};
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease, opacity 0.2s ease;
    white-space: nowrap;
    height: fit-content;

    &:hover:not(:disabled) {
        background-color: ${({ theme }) => theme.palette?.primary?.dark || '#1565c0'};
    }

    &:active:not(:disabled) {
        background-color: ${({ theme }) => theme.tokens?.ColorBlue800 || '#0d47a1'};
    }

    &:disabled {
        background-color: ${({ theme }) => theme.tokens?.BaseColorGray200 || '#ccc'};
        cursor: not-allowed;
        opacity: 0.6;
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.3);
    }
`;

export const GuideTitle = styled.h3`
    font-size: ${({ theme }) => theme.tokens?.SemTypographyListMd?.fontSize || '16px'};
    font-weight: 800;
    margin: 0 0 16px 0;
`;

export const GuideSection = styled.div`
    margin-bottom: 24px;
`;

export const GuideSubTitle = styled.h4`
    font-size: ${({ theme }) => theme.tokens?.SemTypographyListSm?.fontSize || '14px'};
    font-weight: 800;
    margin: 0 0 8px 0;
`;

export const GuideList = styled.ul`
    margin: 0;
    padding-left: 20px;
    list-style-type: disc;
`;

export const GuideListItem = styled.li`
    font-size: 13px;
    line-height: 1.5;
    margin-bottom: 4px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const GuideText = styled.p`
    font-size: 13px;
    line-height: 1.5;
    margin: 0 0 8px 0;

    &:last-child {
        margin-bottom: 0;
    }
`;
